import { ModelConstants } from '../model-constants';
import { IAttribute, IModel, IValidationContext, IViolation } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { AzureKeyVault } from './key-vault';
import { IAzureBlobLinkedServiceValidators } from './azure-blob-fs.linkedservice';
import { format } from '../../shared/utils/string.util';

export const fileServerLinkedServiceValidators: IAzureBlobLinkedServiceValidators = {
    validateAKVLinkedserviceReference: undefined
};

@Metamodel.model({
    name: ModelConstants.fileServerService,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.FileSystem_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.FileSystem_DisplayText)
    ]
})
export class FileServerLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly HOST: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host,
        constraint: {
            validator: FileServerLinkedService.validateHost
        },
        association: 'HOST',
        templatable: true
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: (linkedservice: LinkedService, referencedResource: AzureKeyVault, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                if (fileServerLinkedServiceValidators.validateAKVLinkedserviceReference) {
                    return fileServerLinkedServiceValidators.validateAKVLinkedserviceReference(linkedservice, referencedResource, violation, context);
                }
                return undefined;
            }
        },
        association: 'PASSWORD',
        accepts: ['String'],
        templatable: true
    })
    public password?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public static validateHost(fileserver: FileServerLinkedService): IViolation[] | undefined {
        if (fileserver && fileserver.host) {
            // eslint-disable-next-line
            if (fileserver.host.toLowerCase().startsWith('http:')) {
                return [{
                    context: fileserver,
                    message: () => stringResources.FileSystem_HostStartWithHttp_ErrorMessage
                }];
            }
            if (fileserver.host.toLowerCase().startsWith('ftp:')) {
                return [{
                    context: fileserver,
                    message: () => stringResources.FileSystem_HostStartWithFtp_ErrorMessage
                }];
            }
        }
        return undefined;
    }
}
